export default __webpack_public_path__ + "d4adca4e841799798c12da3d6d564b84.png";